module.exports = __webpack_public_path__ + "img/vn_check1.82df8869.png";